export enum ListItemSize {
    Regular = "regular",
    Compact = "compact",
}
